import { Flex, Box, Heading, Text, UnorderedList, ListItem } from "@chakra-ui/react";
import { SectionDivider } from "app/components/shared/SectionDivider";
import Link from "next/link";
import { GNS3_PRICING_TYPES } from "./constants";

const GNS3PricingTypes = () => {
  return (
    <Flex direction="column" data-cy="section-pricing-types">
      <SectionDivider label={"Choose Your GNS3 Hosted service Edition"} />
      <Flex flexWrap="wrap" justifyContent="center" gap={"2%"} data-cy={"card-pricing"}>
        {GNS3_PRICING_TYPES.map((data, index) => (
          <Box
            key={index}
            p={6}
            boxShadow={"md"}
            border={"1px solid #aaa"}
            borderRadius={"8px"}
            transition={"0.15s"}
            _hover={{
              transform: "scale(1.03)",
              boxShadow: "lg",
            }}
            height={"auto"}
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={"4px"}
            minWidth={"320px"}
            maxWidth={"23%"}
            marginBottom={6}
          >
            <Heading
              as={"h3"}
              textAlign={"center"}
              fontSize={{ base: "md", lg: "lg" }}
              color={"gray.700"}
              mb={3}
            >
              {data.title}
            </Heading>
            <UnorderedList>
              {data.items.map((item, index) => (
                <ListItem key={index}>
                  <Text
                    fontSize={{ base: "md", lg: "lg" }}
                    color={"gray.700"}
                    fontWeight={"600"}
                  >
                    {item.subtitle}
                  </Text>
                  <Text fontSize={{ base: "md", lg: "lg" }}>
                    {item.desc && item.desc}
                  </Text>
                </ListItem>
              ))}
            </UnorderedList>
          </Box>
        ))}
      </Flex>
      <Text
        fontSize={{ base: "md", lg: "lg" }}
        color={"gray.700"}
        fontWeight={"600"}
        textAlign={"center"}
      >
        Not sure which to choose? Our{" "}
        <Link
          href="https://rc.cloudmylab.com/"
          style={{
            color: "#4299e1",
            fontSize: "20px",
            fontWeight: "500",
            textDecoration: "underline",
          }}
          target="_blank"
        >
          Resource Calculator
        </Link>{" "}
        can guide you to the best option for your specific requirements or{" "}
        <Link
          href="#contact-form"
          style={{
            color: "#4299e1",
            fontSize: "20px",
            fontWeight: "500",
            textDecoration: "underline",
          }}
        >
          Contact us
        </Link>
      </Text>
    </Flex>
  );
};

export default GNS3PricingTypes;
